module.exports = __webpack_public_path__ + "img/Kraven-full.62bfe333.png";